import React, { useEffect, useRef, useState } from "react";
import { FaEnvelope } from "react-icons/fa";

const Contact = () => {
  const headingRef = useRef(null);
  const footerRef = useRef(null);

  const [headingVisible, setHeadingVisible] = useState(false);
  const [footerVisible, setFooterVisible] = useState(false);

  useEffect(() => {
    const headingObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setHeadingVisible(true);
      },
      { threshold: 0.25 }
    );

    const footerObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setFooterVisible(true);
      },
      { threshold: 0.25 }
    );

    if (headingRef.current) headingObserver.observe(headingRef.current);
    if (footerRef.current) footerObserver.observe(footerRef.current);

    return () => {
      headingObserver.disconnect();
      footerObserver.disconnect();
    };
  }, []);

  const year = new Date().getFullYear();

  const iconBtn =
    "w-12 h-12 rounded-2xl bg-surface/55 border border-border/60 grid place-items-center " +
    "text-secondaryText hover:text-primaryText hover:border-accent/30 hover:bg-surface/70 " +
    "transition-all duration-200";

  return (
    <section
      id="Contact"
      className="min-h-screen scroll-mt-85 flex items-center justify-center px-6 sm:px-16 py-20 bg-transparent text-primaryText font-sans"
    >
      <div className="w-full max-w-4xl">
        {/* Hero */}
        <div
          ref={headingRef}
          className={`transition-all duration-1000 ease-out text-center ${
            headingVisible
              ? "opacity-100 translate-y-0"
              : "opacity-0 translate-y-10"
          }`}
        >
          <h1 className="text-5xl sm:text-6xl font-extrabold leading-tight">
            <span className="text-primaryText">Let&apos;s Create </span>
            <span className="bg-gradient-to-r from-primaryText to-accent bg-clip-text text-transparent">
              Together
            </span>
          </h1>

          <p className="text-secondaryText mt-4 text-lg max-w-2xl mx-auto leading-relaxed">
            Connect with me. I&apos;m just one message away—whether it&apos;s
            regarding a job opportunity or just a casual conversation.
          </p>

          {/* CTA */}
          <div className="mt-10 flex justify-center">
            <a
              href="mailto:sirisha.raju.lr@gmail.com?subject=Portfolio%20Inquiry"
              className="group inline-flex items-center gap-3 px-10 py-4 rounded-full font-semibold text-background bg-accent shadow-lg shadow-black/30 hover:brightness-110 hover:scale-[1.02] transition-all"
            >
              Start a conversation
              <span className="grid place-items-center w-10 h-10 rounded-full bg-black/15 border border-black/10 group-hover:bg-black/20 transition">
                <FaEnvelope className="text-background" />
              </span>
            </a>
          </div>
        </div>

        {/* Footer row */}
        <div
          ref={footerRef}
          className={`mt-10 flex flex-col sm:flex-row items-center justify-between gap-6 transition-all duration-1000 ease-out ${
            footerVisible
              ? "opacity-100 translate-y-0"
              : "opacity-0 translate-y-6"
          }`}
        ></div>
      </div>
    </section>
  );
};

export default Contact;
